/**
 * The one survivor preview the paperdoll and the Atelier share.
 *
 * A WebGL context is scarce on a phone: the settlement, the HUD portrait and
 * up to three panel previews can already hold one each. The paperdoll and the
 * Atelier are both modal windows, and `closeOtherModals` never lets them be
 * open together, so they borrow one preview instead of building two. Whoever
 * opens calls `mount(theirBox)` and `setActive(true)`; the canvas moves.
 *
 * The paperdoll owns the lifetime (it is built once per base view and
 * disposes on teardown), so `disposeWardrobePreview` is its call.
 */
import { CharacterPreview } from './character-preview';

let shared: CharacterPreview | null = null;

export function wardrobePreview(): CharacterPreview {
  shared ??= new CharacterPreview();
  return shared;
}

export function disposeWardrobePreview(): void {
  shared?.dispose();
  shared = null;
}
